module.exports = __webpack_public_path__ + "static/media/type-5.85af911f.svg";